"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Paper = _interopRequireDefault(require("material-ui/Paper"));
var _ReportHeading = _interopRequireDefault(require("./ReportHeading.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ReportCard(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "container forIphone5s",
    style: {
      paddingLeft: '0',
      paddingRight: '0'
    }
  }, props.loginRedirect && /*#__PURE__*/_react["default"].createElement(Redirect, {
    to: '/'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row",
    id: "main_div_in_container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "sharediv",
    className: "shareDivCss"
  }, /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
    zDepth: 1,
    rounded: false,
    className: "grid grid-row paperCss"
  }, props.playerReports.summaryInfo.length > 0 && /*#__PURE__*/_react["default"].createElement(_ReportHeading["default"], {
    playerReports: playerReports,
    reportCardSetting: props.reportCardSetting.filter(function (reopFilter) {
      return reopFilter.gameType === props.gameType;
    })[0],
    onSettingsClick: props.reportSettingsOpen()
  })))));
}
var _default = ReportCard;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/reportCard.js
 ** module id = 2404
 ** module chunks = 0
 **/